export const toastMsg = {
    afterReview: 'Your reports has been submitted!',
    failedReview: 'Failed to save',
    afterFeedback: 'Thank you for your feedback',
    selectImage: 'Selected',
    reportSent: 'Your reports has been sent to your email!',
    failedToSent: 'Failed to send email.Try again later',
    isSubmitReport: 'you have not scheduled any work to be completed.',
    proNotAccepted: 'Pro not yet completed ',
    noPdfFound: 'No pdf has been uploaded',

    /**Login error */
    successLogin: 'Loggedin successfully',
    failedLogin: 'Invalid Report Id',
    networkError: 'Network error',
    success: 'success',
    failed: 'failed',
};


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/main/content/utils/toast-values.ts